import my from "../my";

export default function authorize() {
     return my.authorize({
        scopes: "*"
    });
}

